
const state = {
    loading : false
}

// getters
const getters = {
 
}

// actions
const actions = {
    
    
}

// mutations
const mutations = {
    setLoadingState(state, isLoading) {
        state.loading = isLoading;
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}